<template>
  <div class="count" :class="{ visible: index <= currentIndex }">
    <Transition name="slide-up" mode="out-in" @after-enter="handleAfterEnter">
      <span
        :key="`val-${currentValue}`"
        :ref="`val-${currentValue}`"
        class="count-item"
      >
        {{ currentValue }}
      </span>
    </Transition>
  </div>
</template>

<script setup lang="ts">
interface Props {
  finalValue: number;
  delay: number;
  index: number;
  currentIndex: number;
}

const props = defineProps({
  finalValue: null,
  delay: null,
  index: null,
  currentIndex: null
});

const diffToCompleteAnimation = props.finalValue;

const emit = defineEmits(["complete"]);

const currentValue = ref<number>(0);

const updateIndex = () => {
  if (currentValue.value < props.finalValue) {
    currentValue.value += 1;
  } else if (currentValue.value < diffToCompleteAnimation) {
    emit('complete', props.index);
  }
  if (currentValue.value >= diffToCompleteAnimation) {
    emit('complete', props.index);
  }
};

const handleAfterEnter = () => {
  updateIndex();
};

const timeToAnimate = computed(() => {
  return props.currentIndex === props.index;
});

watch(
  () => timeToAnimate.value,
  (b) => {
    if (b) {
      updateIndex();
    }
  }
);

onMounted(() => {
  if (timeToAnimate.value) updateIndex();
});
</script>

<style lang="scss" scoped>
.count {
  display: flex;
  visibility: hidden;
  align-items: center;
  justify-content: center;
  width: 6rem;
  height: 10rem;
  perspective: 3000px;
  perspective-origin: 50% center;
  &.visible {
    visibility: visible;
  }
}

.count-item {
  @include font('xxl', 600, 'secondary');

  color: var(--color_neutral_25);
  font-size: 8rem;
}

.slide-up-enter-active {
  transition: all 80ms $ease-in-quad;
}

.slide-up-leave-active {
  transition: all 60ms $ease-out-cubic;
}

.slide-up-enter-from {
  transform: translateZ(50rem);
}

.slide-up-leave-to {
  transform: translateZ(-20rem);

  // transform: scale(0.9rem);
}
</style>
